module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.5637/images/default-avatar.png"